<template>
  <div id="header">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
      <router-link :to="{ name: 'Top' }" class="navbar-brand">
        巡回点検業務管理システム
        <span class="badge badge-pill badge-secondary" v-if="isDev">dev</span>
        <span class="badge badge-pill badge-warning" v-if="isStg">stg</span>
      </router-link>
      <button class="navbar-toggler collapsed" type="button"
          data-toggle="collapse"
          data-target="#navbar-nav-items"
          aria-controls="navbar-nav-items"
          aria-expanded="false"
          aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse" id="navbar-nav-items" v-show="isLoggedIn" ref="navbarCollapse">
        <ul class="navbar-nav mr-auto" @click="onNavVarClick">
          <li class="nav-item">
            <router-link :to="{ name: 'Top' }" class="nav-link" exact>
              トップ
            </router-link>
          </li>
          <template v-if="isPageGroupA">
            <li class="nav-item">
              <router-link :to="{ name: 'RojouTenken' }" class="nav-link">
                路上巡回点検
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'RokaTenken' }" class="nav-link">
                路下巡回点検
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'KoukashitaTenken' }" class="nav-link">
                高架下巡回点検
              </router-link>
            </li>
          </template>
          <template v-if="isPageGroupB">
            <li class="nav-item">
              <router-link :to="{ name: 'TenkenReport' }" class="nav-link">
                報告書作成
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'HoshuReport' }" class="nav-link">
                点検補修台帳出力
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'Search' }" class="nav-link">
                検索
              </router-link>
            </li>
            <li class="nav-item" v-if="isAdmin">
              <router-link :to="{ name: 'AdminTop' }" class="nav-link">
                コード管理
              </router-link>
            </li>
          </template>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <span class="user-display-name">
              ユーザー名：{{username}}
            </span>
            <span class="nav-item ib logout ml12" @click="logout">
              <i class="fas fa-sign-out-alt mr4"></i>ログアウト
            </span>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'global-header',
  data() {
    return {}
  },
  computed: {
    ...mapState('user', {
      username: state => state.username,
      isAdmin: state => state.has_role_admin,
      env: state => state.env,
    }),
    ...mapGetters('user', [
      'isLoggedIn',
    ]),
    isDev() {
      return this.env === 'development'
    },
    isStg() {
      return this.env === 'staging'
    },
    isPageGroupA() {
      const routePath = this.$route.path
      return (routePath.startsWith('/rojou-tenken')) ||
        (routePath.startsWith('/roka-tenken')) ||
        (routePath.startsWith('/koukashita-tenken'))
    },
    isPageGroupB() {
      const routePath = this.$route.path
      return (routePath.startsWith('/tenken-report')) ||
        (routePath.startsWith('/hoshu-report')) ||
        (routePath.startsWith('/search')) ||
        (routePath.startsWith('/admin'))
    },
  },
  methods: {
    onNavVarClick(evt) {
      // 押されたら閉じる
      const target = evt.target
      if (target.classList.contains('nav-link')) {
        this.toggleHamburgerMenu()
      }
    },
    toggleHamburgerMenu() {
      const navBar = this.$refs.navbarCollapse
      if (navBar.classList.contains('show')) {
        navBar.classList.remove('show')
      } else {
        navBar.classList.add('show')
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      await this.$store.dispatch('localStorage/set', {
        key: 'serverToken',
        val: null,
      })
      // want to explicitly reload
      location.href = '/login'
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-item.top {

}
.nav-link {
  font-size: 16px;
}
.user-display-name {
  color: rgba(255, 255, 255, 0.7);
}
.logout {
  color: #ffffff;
  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
}
</style>
